import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

type CompanyState = CommonTableState;

const initialState: CompanyState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "name", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            email: false,
            phone: false,
            dataBox: false,
            foundByReg: false,
            created: false,
            creator: false,
        },
        columnOrder: [
            "name",
            "vatNumber",
            "idNumber",
            "vatPayer",
            "active",
            "email",
            "phone",
            "dataBox",
            "foundByReg",
            "creator",
            "created",
            "mrt-row-actions",
        ],
        density: "compact",
    },
};

export const companySlice = createSlice({
    name: "company",
    initialState: initialState,
    reducers: {
        updateCompanyTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const {updateCompanyTableState} = companySlice.actions;

export default companySlice.reducer;
